
import { VTextarea } from 'vuetify/lib';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({ name: 'd4y-textarea' })
export default class D4yTextarea extends VTextarea {
  @Prop({ default: false })
  rounded!: boolean;
  @Prop({ default: true })
  outlined!: boolean;
  @Prop({ default: true })
  dense!: boolean;
}
